module.exports = __webpack_public_path__ + "static/media/form-ilustracia.68027a31.svg";